import Vue from 'vue';
import {HttpOptions} from 'vue-resource/types/vue_resource';
import * as config from '@/utils/config'
import {BarChartData} from '@/models/chart-data'
import {OidcService} from '@/services/oidc-service';

export class CostsService extends Vue {
    private oidcService: OidcService = new OidcService();

    options: HttpOptions = {
        headers: {
            'Authorization': ''
        },
    };

    constructor() {
        super();
    }

    public async getBarChart(chartName: string): Promise<BarChartData> {
        const access_token =  await this.oidcService.getAccessToken();
        this.options.headers['Authorization'] = 'Bearer ' + access_token;
        return new Promise((resolve, reject) => {
            this.$http.get(config.REDANKA_BE_BASE_URL + '/costs/chart?chartName=' + chartName, this.options)
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.error('Error: ', error);
                        reject(error);
                    });
        });
    }

}